import React from 'react';

export const CalendarDayOffEventContent = ({ title }) => (
  <div className="calendar-dayoff-event-title">
    {title}
  </div>
);

export const CalendarMonthEventCircle = ({ allDay, backgroundColor, borderColor }) => (
  <div
    className={`event-circle ${allDay ? 'all-day' : 'time-based'}`}
    style={{
      '--event-circle-fill': allDay ? backgroundColor : 'transparent',
      '--event-circle-border': borderColor,
    }}
  >
    <div className="circle" />
  </div>
);

export const CalendarTimeGridEventContent = ({ title }) => (
  <div className="calendar-timegrid-event-title">
    {title}
  </div>
);
